/***************************************************************************
 * COPYRIGHT (C) 2015, Rapid7 LLC, Boston, MA, USA.
 * All rights reserved.本書には、Rapid7の機密情報および占有情報
 * を含む、未公開の著作物が記載されています。
 **************************************************************************/

/* jshint maxlen: false */
export default {
  insightvmNavMenus: {
    ftux: {
      back: '戻る',
      cardLibrary: {
        content: {
          description:
            '独自のダッシュボードを作成して関心のある見解に焦点を当てます。 ' +
            '利害関係者向けにカスタムビューをコンパイルします。',
        },
        title: '独自のビューを作成',
      },
      cards: {
        content: {
          description:
            '包括的なフィルター機能を利用してデータを探索し絞り込みます。',
        },
        title: '展開とフィルター',
      },
      dashboards: {
        content: {
          description:
            'ニーズに適した情報を提供する専用ダッシュボードをお試しください。',
        },
        title: 'ダッシュボードライブラリ',
      },
      end: '終了',
      endTour: '見学終了',
      info: {
        description:
          'このメニューからいつでもダッシュボードツアーにアクセスできます。',
      },
      navigation: {
        content: {
          description:
            '直感的ダッシュボードと視覚化によりデータについての見解を即座に得られます。',
        },
        title: 'ナビゲーション',
      },
      next: '次へ',
      ok: 'Ok',
      steps: '(__end__の__start__)',
      welcome: {
        content: {
          description:
            '次のスキャン日より前に脆弱性を検出するリアルタイムダッシュボードおよび ' +
            'ITセキュリティで行うべき事項を優先順位付けする適応ワークフローをご体験ください。',
          header: '新規Nexposeへようこそ',
        },
        dismiss: '棄却',
        quickTour: '簡単に見学ツアーする',
      },
    },
    leftNav: {
      administration: '管理',
      assets: 'アセット',
      dashboard: 'ダッシュボード',
      home: 'ホーム',
      policies: 'ポリシー',
      projects: 'プロジェクト',
      reports: 'レポート',
      tickets: 'チケット',
      vulnerabilities: '脆弱性',
    },
    topNav: {
      assetGroup: 'アセット・グループ',
      changePassword: 'パスワードを変更',
      create: '作成',
      dynamicAssetGroup: '動的アセット・グループ',
      help: 'ヘルプ',
      logoff: 'ログオフ',
      report: 'レポート',
      search: '検索',
      site: 'サイト',
      support: 'サポート',
      tags: 'タグ',
      tour: 'ツアー',
      userPreferences: 'ユーザープリファレンス',
    },
  },
};
